import { render, staticRenderFns } from "./DamageGallery.vue?vue&type=template&id=89d09abc&"
import script from "./DamageGallery.vue?vue&type=script&lang=js&"
export * from "./DamageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports